import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-82f3f86e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collect_card" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = {
  key: 0,
  class: "card_wrap"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "no_data"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无内容", -1))
const _hoisted_7 = [
  _hoisted_6
]

import { nextTick, onMounted, reactive, ref } from 'vue'
import ActionBar from '@/components/ActionBar/index.vue'
import CardGroup from '@/components/WordCard/CardGroup.vue'
import { getStatusBarInfo, nativeGoBack } from '@/utils/nativeFn'
import VConsole from 'vconsole'
import { redotClear, cardList } from '@/api/index'
import { useBaseNative } from '@/utils/hooks'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectCard',
  setup(__props) {

const { actionBarHeight, goBack, setToken } = useBaseNative()

const actionBarInfo = reactive({
  actionBarTitle: '识字卡',
  actionBarBg: '#ffeec4'
})

const route = useRoute()
const list = ref([])
const newCardIds = ref([])

onMounted(async () => {
  console.log(process.env)
  if (process.env.NODE_ENV === 'development') {
    const vConsole = new VConsole()
  }
  setToken()
  getList()
})

const getList = async () => {
  const ret = await cardList({
    book_grade_unionid: route.query.book_grade_unionid
  })
  if (ret?.data?.code !== 0) {
    return
  }
  list.value = ret?.data?.data?.card_list
  // const res = require('./mock.json')
  // list.value = res.data.card_list
  nextTick(() => {
    redotClear({ redot_type: 1 })
    goCurrentBook()
  })
}

const goCurrentBook = () => {
  const id = newCardIds.value.shift()

  if (!id) return
  // JS屏幕滚动
  const scrolly = (document.querySelector(id) as HTMLElement).offsetTop
  const collect_card = document.querySelector('.collect_card')
  let distance = scrolly - collect_card.scrollTop - actionBarHeight.value - 30
  let everyDistance = distance / 100
  for (let i = 0; i <= 100; i++) {
    setTimeout(() => {
      collect_card.scrollBy(100, everyDistance)
    }, 10 * i)
  }
}

const newCardRecord = (id) => {
  newCardIds.value.push(id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ActionBar, {
      onGoBack: _unref(goBack),
      actionBarInfo: actionBarInfo,
      backIcon: require('../../assets/images/card/back.png')
    }, null, 8, ["onGoBack", "actionBarInfo", "backIcon"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "bar",
        style: _normalizeStyle({ paddingTop: _unref(actionBarHeight) + 'px' })
      }, null, 4),
      (list.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                id: 'card_wrap_' + item.book_lecture_id,
                key: item.book_lecture_id
              }, [
                _createVNode(CardGroup, {
                  data: item,
                  Id: '#card_wrap_' + item.book_lecture_id,
                  onNewCardRecord: newCardRecord
                }, null, 8, ["data", "Id"])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
    ])
  ]))
}
}

})